import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "donation-options",
  style: {"display":"flex","gap":"2rem","justify-content":"center","margin":"2rem 0 3rem"}
}
const _hoisted_4 = {
  key: 0,
  id: "moneySection"
}
const _hoisted_5 = {
  class: "program-grid",
  style: {"margin-bottom":"3rem"}
}
const _hoisted_6 = { class: "program-card" }
const _hoisted_7 = {
  class: "program-card",
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","gap":"1.5rem"}
}
const _hoisted_8 = {
  key: 1,
  id: "equipmentSection"
}
const _hoisted_9 = { class: "cta" }
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "cta-buttons" }

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'DonateView',
  setup(__props) {

const route = useRoute()
const currentSection = ref<'money' | 'equipment'>('money')

onMounted(() => {
  // Check for section query parameter
  const section = route.query.section as string
  if (section === 'equipment') {
    currentSection.value = 'equipment'
  } else if (section === 'money') {
    currentSection.value = 'money'
  }

  // Load Givebutter widget script if not already loaded
  if (!document.querySelector('script[src*="widgets.givebutter.com"]')) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://widgets.givebutter.com/latest.umd.cjs?acct=ksC8Ep1sarshQQeS&p=other'
    document.head.appendChild(script)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_givebutter_widget = _resolveComponent("givebutter-widget")!

  return (_openBlock(), _createElementBlock("main", null, [
    _cache[19] || (_cache[19] = _createElementVNode("section", { class: "hero" }, [
      _createElementVNode("div", { class: "hero-content" }, [
        _createElementVNode("h2", null, "Support Our Mission"),
        _createElementVNode("p", null, "Help us provide technology to students across Brevard County")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", { style: {"text-align":"center"} }, "How to Donate", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", { style: {"text-align":"center","margin-bottom":"2rem"} }, "Choose how you'd like to support our mission", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (currentSection.value = 'money')),
            class: _normalizeClass(["btn btn-primary", { active: currentSection.value === 'money' }]),
            style: {"cursor":"pointer"}
          }, " Donate Money ", 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (currentSection.value = 'equipment')),
            class: _normalizeClass(["btn btn-secondary", { active: currentSection.value === 'equipment' }]),
            style: {"cursor":"pointer"}
          }, " Donate Equipment ", 2)
        ]),
        (currentSection.value === 'money')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[11] || (_cache[11] = _createElementVNode("h3", { style: {"text-align":"center","margin-bottom":"1.5rem"} }, "Financial Donations", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Where Your Money Goes", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("p", null, "Space Coast STEM is an entirely volunteer-run organization. Our board members personally cover all operational expenses including website hosting, insurance, and administrative costs.", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, [
                    _createElementVNode("strong", null, "This means 100% of your donation goes directly toward:")
                  ], -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("ul", null, [
                    _createElementVNode("li", null, "Purchasing laptops and computer equipment for students"),
                    _createElementVNode("li", null, "Replacement parts for refurbishment projects"),
                    _createElementVNode("li", null, "Tools and materials for computer repairs")
                  ], -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("p", { style: {"margin-top":"1.5rem"} }, [
                    _createElementVNode("strong", null, "Leveraging Bulk Buying Power:")
                  ], -1)),
                  _createElementVNode("p", null, [
                    _cache[3] || (_cache[3] = _createTextVNode("By pooling donations together, we can purchase decommissioned school laptops in bulk from government surplus auctions at wholesale prices—as low as $5 per laptop when buying 500+. This means your donation can have a much greater impact than buying laptops individually. Learn more about ", -1)),
                    _createVNode(_component_router_link, {
                      to: "/theplan",
                      style: {"color":"#3ba3d1","font-weight":"600"}
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("our plan", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[4] || (_cache[4] = _createTextVNode(" to scale our impact.", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "tip-notice" }, [
                    _createElementVNode("h4", { style: {"margin":"0 0 0.5rem 0","color":"#e67e22","font-size":"1rem"} }, [
                      _createElementVNode("span", { style: {"font-size":"1.2rem"} }, "⚠️"),
                      _createTextVNode(" About the Platform Tip ")
                    ]),
                    _createElementVNode("p", { style: {"margin":"0","font-size":"0.9rem","line-height":"1.6"} }, [
                      _createTextVNode(" Givebutter waives their platform fee when we give donors the "),
                      _createElementVNode("strong", null, "option"),
                      _createTextVNode(" to leave a tip. The default tip is "),
                      _createElementVNode("strong", null, "15%"),
                      _createTextVNode(" but you can adjust this to any amount (including "),
                      _createElementVNode("strong", null, "$0"),
                      _createTextVNode(") by clicking the tip ammount and then \""),
                      _createElementVNode("strong", null, "Other"),
                      _createTextVNode("\" in the tip section. ")
                    ])
                  ], -1)),
                  _createVNode(_component_givebutter_widget, { id: "LPRmnp" })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (currentSection.value === 'equipment')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[12] || (_cache[12] = [
              _createStaticVNode("<h3 style=\"text-align:center;margin-bottom:1.5rem;\" data-v-2f956870>Equipment Donations</h3><div class=\"program-grid\" style=\"margin-bottom:3rem;\" data-v-2f956870><div class=\"program-card\" data-v-2f956870><h4 data-v-2f956870>What We Accept</h4><p data-v-2f956870>We accept donations of working computers and peripherals that can be refurbished and given to students in need.</p><ul style=\"margin-top:1rem;\" data-v-2f956870><li data-v-2f956870>Desktop computers</li><li data-v-2f956870>Laptops</li><li data-v-2f956870>Computer peripherals (keyboards, mice, monitors)</li><li data-v-2f956870>Replacement parts (RAM, storage drives, batteries)</li><li data-v-2f956870>Other technology equipment (tablets, routers)</li></ul></div><div class=\"program-card\" data-v-2f956870><h4 data-v-2f956870>Minimum Requirements for Computers</h4><p data-v-2f956870><strong data-v-2f956870>Laptops:</strong></p><ul data-v-2f956870><li data-v-2f956870>Intel Core i3 (3rd gen+) or equivalent AMD</li><li data-v-2f956870>4GB RAM minimum (8GB preferred)</li><li data-v-2f956870>Working battery that holds a charge</li><li data-v-2f956870>Functional screen, keyboard, and trackpad</li></ul><p style=\"margin-top:1rem;\" data-v-2f956870><strong data-v-2f956870>Desktops:</strong></p><ul data-v-2f956870><li data-v-2f956870>Intel Core i3 (3rd gen+) or equivalent AMD</li><li data-v-2f956870>4GB RAM minimum (8GB preferred)</li><li data-v-2f956870>All components functioning properly</li></ul></div></div><div class=\"contact-form\" data-v-2f956870><h4 style=\"text-align:center;margin-bottom:1.5rem;\" data-v-2f956870>Equipment Donation Form</h4><p style=\"text-align:center;margin-bottom:2rem;\" data-v-2f956870>Please email us at <strong data-v-2f956870>donations@spacecoaststem.org</strong> with details about the equipment you&#39;d like to donate. Include:</p><ul style=\"max-width:600px;margin:0 auto 2rem;text-align:left;\" data-v-2f956870><li data-v-2f956870>Your contact information</li><li data-v-2f956870>Device type, brand, and model</li><li data-v-2f956870>Specifications (processor, RAM, storage)</li><li data-v-2f956870>Condition of the device</li><li data-v-2f956870>Number of devices</li><li data-v-2f956870>Your location in Brevard County</li></ul></div>", 3)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[20] || (_cache[20] = _createStaticVNode("<section class=\"impact-section\" data-v-2f956870><div class=\"container\" data-v-2f956870><h2 data-v-2f956870>Impact of Your Donation</h2><p data-v-2f956870>Every donation makes a real difference in a student&#39;s life:</p><div class=\"impact-grid\" data-v-2f956870><div class=\"impact-card\" data-v-2f956870><div class=\"impact-icon\" data-v-2f956870>💻</div><h3 data-v-2f956870>Access to Technology</h3><p data-v-2f956870>Students receive laptops they can use for homework, research, and learning new skills</p></div><div class=\"impact-card\" data-v-2f956870><div class=\"impact-icon\" data-v-2f956870>📚</div><h3 data-v-2f956870>Educational Opportunity</h3><p data-v-2f956870>Technology opens doors to online courses, educational resources, and college applications</p></div><div class=\"impact-card\" data-v-2f956870><div class=\"impact-icon\" data-v-2f956870>♻️</div><h3 data-v-2f956870>Environmental Impact</h3><p data-v-2f956870>Equipment donations keep computers out of landfills while serving students</p></div><div class=\"impact-card\" data-v-2f956870><div class=\"impact-icon\" data-v-2f956870>🌟</div><h3 data-v-2f956870>Future Success</h3><p data-v-2f956870>Digital literacy prepares students for college and careers</p></div></div></div></section>", 1)),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[17] || (_cache[17] = _createElementVNode("h2", null, "Questions About Donating?", -1)),
        _cache[18] || (_cache[18] = _createElementVNode("p", null, "Contact us to learn more about donations or other ways to support our mission", -1)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "btn btn-primary"
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode("Contact Us", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/about",
            class: "btn btn-secondary"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("Learn More About Us", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})